import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ROpt } from '../ROpt';
import { WCta } from '../WCta';
import { WregPhase } from '../WregPhase';
import { WREG_WORKING_MS } from '../wregSteps';

type Props = {
  onAccept: () => void | Promise<void>;
  onAccepted: () => void;
  onDecline: () => void;
};

const WregAgreement = ({ onAccept, onAccepted, onDecline }: Props) => {
  const { t } = useTranslation();
  const [ok, setOk] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const showError = submitAttempted && !ok;
  const validateBeforeSubmit = () => {
    if (ok) return true;
    setSubmitAttempted(true);
    requestAnimationFrame(() => {
      const control = document.getElementById('wreg-agreement-accept');
      control?.focus();
      control?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
    });
    return false;
  };
  return (
    <div className="rg-screen">
      <div className="rg-body-wrap">
        <div className="rg-body">
          <div className="rg-inner">
            <div className="rg-head-block">
              <WregPhase n={2} />
              <h1 className="rg-h1">{t('wreg.agree.title')}</h1>
            </div>
            <div className="wreg-agree-box">
              <p className="wreg-agree-text">
                {t('wreg.agree.box.pre')}
                <a
                  className="c-link"
                  href={t('general.links.tos')}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('wreg.agree.box.tos')}
                </a>
                {t('wreg.agree.box.post')}
              </p>
              <ROpt
                id="wreg-agreement-accept"
                on={ok}
                onClick={() => setOk(!ok)}
                title={t('wreg.agree.check')}
                invalid={showError}
                describedBy={showError ? 'wreg-agreement-accept-err' : undefined}
              />
              {showError && (
                <span className="rg-error-hint" id="wreg-agreement-accept-err" role="alert">
                  Please accept the Terms of Service to continue.
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="rg-foot">
        <div className="rg-foot-stack c-btnset">
          <WCta
            beforeClick={validateBeforeSubmit}
            dimmed={!ok}
            minWorkingMs={WREG_WORKING_MS}
            onClick={onAccept}
            onDone={onAccepted}
          >
            {t('wreg.agree.cta')}
          </WCta>
          <button
            type="button"
            className="dsb dsb-tertiary dsb-s wreg-decline"
            onClick={onDecline}
          >
            {t('wreg.agree.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};

export { WregAgreement };
